import React from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow } from '@mui/material';
import { Skeleton } from '../../../../../../components';

const MutationsTableSkeleton = ({ rows = 10, columns = 4 }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, idx) => (
        <TableRow key={idx}>
          {Array.from({ length: columns }).map((_, colIdx) => (
            <TableCell key={colIdx}>
              <Skeleton />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
};

MutationsTableSkeleton.propTypes = {
  rows: PropTypes.number,
  columns: PropTypes.number,
};

export default MutationsTableSkeleton;
